export const SETROUTE = "SETROUTE";
export const SETHEADERMENU = "SETHEADERMENU";
export const SETHEADERSUBMENU = "SETHEADERSUBMENU";
export const SETDATALOADING = "SETDATALOADING";
export const SETFOOTER = "SETFOOTER";
export const SETFOOTERURLIMG = "SETFOOTERURLIMG";
export const SETHEADERURLIMG = "SETHEADERURLIMG";
export const SETMENUSIDEBAR = "SETMENUSIDEBAR";
export const SETACTIVEMENUSIDEBAR = "SETACTIVEMENUSIDEBAR";
